import React from "react";
import { Container, Row } from "react-bootstrap";
import { DefaultHeaderProps, IHeaderProps } from "./Header.types";
import HeaderStyles from "./Header.styles";
import AppMedia from "../../theme/utils/AppMedia";
import DESKTOP_LOGO from "../logo/DesktopLogo.component";
import MOBILE_LOGO from "../logo/MobileLogo.component";

const { Media } = AppMedia;

const HEADER: React.FC<IHeaderProps> = (props: IHeaderProps) => {
  return (
    <>
      <Media lessThan="tablet">
        <HeaderStyles.Header
          className="ce-soar-header mobile"
          data-testid="mobile-header"
        >
          <Container fluid>
            <Row>
              <HeaderStyles.LogoColumn className="logo-column" xs={1}>
                <MOBILE_LOGO color="#fff" width={30} />
              </HeaderStyles.LogoColumn>
              <HeaderStyles.TitleColumn className="title-column mobile">
                <h1>Streetlight Outages</h1>
              </HeaderStyles.TitleColumn>
            </Row>
          </Container>
        </HeaderStyles.Header>
      </Media>
      <Media greaterThanOrEqual="tablet">
        <HeaderStyles.Header
          className="ce-soar-header"
          data-testid="desktop-header"
        >
          <Container fluid>
            <Row>
              <HeaderStyles.LogoColumn className="logo-column" xs={1}>
                <DESKTOP_LOGO color="#fff" width={125} />
              </HeaderStyles.LogoColumn>
              <HeaderStyles.TitleColumn className="title-column">
                <h1>Streetlight Outages</h1>
              </HeaderStyles.TitleColumn>
            </Row>
          </Container>
        </HeaderStyles.Header>
      </Media>
    </>
  );
};

HEADER.defaultProps = DefaultHeaderProps;
export default HEADER;
